import { render, staticRenderFns } from "./SampleComponent.vue?vue&type=template&id=f505ef0e&scoped=true&"
import script from "./SampleComponent.vue?vue&type=script&lang=js&"
export * from "./SampleComponent.vue?vue&type=script&lang=js&"
import style0 from "./SampleComponent.vue?vue&type=style&index=0&id=f505ef0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f505ef0e",
  null
  
)

export default component.exports